import { motion } from "framer-motion";
import { MANIFESTO } from "./data";

export const Manifesto = () => {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative py-28 px-5 border-t hairline">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mb-16"
        >
          <p className="font-mono text-xs tracking-[0.3em] uppercase overline mb-4">
            / The Brainstem Manifesto
          </p>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight txt-primary">
            How we build.
          </h2>
        </motion.div>

        <div className="border-t hairline">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.no}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              data-testid={`manifesto-chapter-${m.no}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-9 items-baseline border-b hairline"
            >
              <div className="md:col-span-2">
                <span className="font-heading text-5xl font-extrabold text-outline group-hover:text-gradient transition-all duration-500">
                  {m.no}
                </span>
              </div>
              <h3 className="md:col-span-4 font-heading text-2xl font-bold txt-primary">
                {m.title}
              </h3>
              <p className="md:col-span-6 txt-soft leading-relaxed text-lg">{m.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
